<template>
  <button
    v-if="shown"
    v-tooltip.bottom="!enabled ? 'Preview will be available once you save this step.' : null"
    class="btn btn-link d-inline-block"
    :class="enabled ? 'preview preview-link-' + stepId : 'previewDisabled previewDisabled-' + stepId"
    data-test="step-preview-button"
    @click="onClick"
  >
    <span>Preview</span>
  </button>
</template>

<script>
const skippedActivityTypes = [
  'radios',
  'facebook-page-posts',
  'facebook-personal-posts',
  'twitter-personal-posts',
  'linkedin-personal-posts',
  'details',
  'widgets',
  'ads',
  'texts',
  'subscribed-contact-through-campaign',
  'script',
];

export default {
  name: 'step-preview-button',
  props: {
    activityType: {
      type: String,
      required: true,
    },
    editStatus: {
      type: String,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    shown() {
      return !skippedActivityTypes.includes(this.activityType);
    },
    enabled() {
      return this.editStatus !== 'required';
    },
  },
  methods: {
    onClick() {
      if (this.enabled) {
        this.$emit('open-preview');
      }
    },
  },
};
</script>
